import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["state"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEvent, useWrapElement } from 'ariakit-utils/hooks';
import { createHook, createComponent, createElement } from 'ariakit-utils/system';
import { useDialogDisclosure } from '../dialog/dialog-disclosure.js';
import { P as PopoverContext } from '../__utils-3e6151ed.js';
import { usePopoverAnchor } from './popover-anchor.js';
import { jsx } from 'react/jsx-runtime';
var usePopoverDisclosure = createHook(function (_ref) {
  var state = _ref.state,
      props = _objectWithoutProperties(_ref, _excluded);

  var onClickProp = props.onClick;
  var onClick = useEvent(function (event) {
    state.anchorRef.current = event.currentTarget;
    onClickProp == null ? void 0 : onClickProp(event);
  });
  props = useWrapElement(props, function (element) {
    return /*#__PURE__*/jsx(PopoverContext.Provider, {
      value: state,
      children: element
    });
  }, [state]);
  props = _objectSpread(_objectSpread({}, props), {}, {
    onClick: onClick
  });
  props = usePopoverAnchor(_objectSpread({
    state: state
  }, props));
  props = useDialogDisclosure(_objectSpread({
    state: state
  }, props));
  return props;
});
/**
 * A component that renders a button that controls the visibility of the popover
 * when clicked.
 * @see https://ariakit.org/components/popover
 * @example
 * ```jsx
 * const popover = usePopoverState();
 * <PopoverDisclosure state={popover}>Disclosure</PopoverDisclosure>
 * <Popover state={popover}>Popover</Popover>
 * ```
 */

var PopoverDisclosure = createComponent(function (props) {
  var htmlProps = usePopoverDisclosure(props);
  return createElement("button", htmlProps);
});
export { PopoverDisclosure, usePopoverDisclosure };